/* istanbul ignore next */
const ACTIONS = {
    GET_PURCHASE_ORDER: 'GET_PURCHASE_ORDER',
    GET_PURCHASE_ORDER_SUCCESS: 'GET_PURCHASE_ORDER_SUCCESS',
    GET_PURCHASE_ORDER_ERROR: 'GET_PURCHASE_ORDER_ERROR',
    RECORD_APPROVAL: 'RECORD_APPROVAL',
    RECORD_APPROVAL_ERROR: 'RECORD_APPROVAL_ERROR',
    PRE_POPULATE_LOCAL_STATE_PO: 'PRE_POPULATE_LOCAL_STATE_PO'
};

/* istanbul ignore next */
const ACTION_CREATORS = {
    getPurchaseOrder() {
        return {
            type: ACTIONS.GET_PURCHASE_ORDER
        };
    },

    getPurchaseOrderSuccess(fileURL, file) {
        return {
            type: ACTIONS.GET_PURCHASE_ORDER_SUCCESS,
            payload: {
                fileURL,
                file
            }
        };
    },

    getPurchaseOrderError(errorKey) {
        return {
            type: ACTIONS.GET_PURCHASE_ORDER_ERROR,
            payload: {
                errorKey
            }
        };
    },

    recordApproval(commercialOfferType, advertiserBusinessModel, accountUuid, isPmis) {
        return {
            type: ACTIONS.RECORD_APPROVAL,
            payload: {
                commercialOfferType,
                advertiserBusinessModel,
                accountUuid,
                isPmis
            }
        };
    },

    recordApprovalError(errorKey) {
        return {
            type: ACTIONS.RECORD_APPROVAL_ERROR,
            payload: {
                errorKey
            }
        };
    },

    prePopulateLocalState(publicUuid) {
        return {
            type: ACTIONS.PRE_POPULATE_LOCAL_STATE_PO,
            payload: {
                publicUuid
            }
        };
    }
};

export default {
    ...ACTIONS,
    ...ACTION_CREATORS
};
